import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

// Shell genérico dos cards com gradient do tema playful. Cada tela compõe seu
// próprio conteúdo via children em vez de props de dados — layouts variam demais
// entre os usos (ex.: banner de pontos de ponta a ponta no desafio da semana) para
// caber numa API só de props.
function PlayfulCard({ badge, className, style, onClick, children }) {
  return (
    <div
      className={cn('relative flex flex-col rounded-2xl border border-neutral-lightest shadow-card transition-shadow duration-150 hover:shadow-card-hover', onClick && 'cursor-pointer', className)}
      // Gradiente por padrão pensado pra card com ícone pequeno (o wash inteiro
      // fica visível). Card com imagem de topo cobrindo boa parte da altura
      // precisa de um gradiente próprio — `style` deixa sobrescrever o
      // `background` sem duplicar o resto do shell.
      style={{ background: 'linear-gradient(180deg, #F4FDFF 0%, #F2FCFF 14.65%, #FFFCF1 27.71%)', ...style }}
      onClick={onClick}
    >
      {badge && (
        <Badge
          variant={badge.variant}
          className={cn('absolute right-3 top-3 rounded-[4px] px-1.5 py-0.5 text-[10px] font-extrabold uppercase leading-none tracking-wide shadow-sm', badge.className)}
        >
          {badge.text}
        </Badge>
      )}
      {children}
    </div>
  );
}

// Botão pill usado no rodapé desses cards. stopPropagation por padrão porque o
// card costuma ter onClick próprio (o botão não deve disparar a ação 2x).
// forwardRef porque também é usado como DropdownMenuTrigger (Radix precisa do
// ref pra medir/posicionar o menu).
const PlayfulCardButton = React.forwardRef(({ children, icon: Icon, disabled = false, variant = 'continue', onClick, className, ...props }, ref) => {
  const isRose = variant === 'rose';
  const isOutline = variant === 'outline';

  const handleClick = e => {
    e.stopPropagation();
    onClick?.(e);
  };

  return (
    <button
      ref={ref}
      type="button"
      disabled={disabled}
      onClick={handleClick}
      className={cn(
        'flex w-full items-center justify-center gap-2 rounded-full py-2.5 text-sm font-extrabold transition-transform duration-100 active:translate-y-px',
        isOutline ? 'border border-[var(--color-mission)] bg-white text-[var(--color-mission)]' : 'text-white',
        disabled && 'cursor-not-allowed bg-[#FFECD8]',
        className
      )}
      style={disabled || isOutline ? undefined : { background: isRose ? 'linear-gradient(180deg, #FF7A93 0%, #FF4C6F 100%)' : 'var(--gradient-btn-continue)', boxShadow: isRose ? '0 3px 0 #C93B58' : '0 3px 0 var(--color-mission-dark)' }}
      {...props}
    >
      {Icon && <Icon className="h-4 w-4" />}
      {children}
    </button>
  );
});
PlayfulCardButton.displayName = 'PlayfulCardButton';

export { PlayfulCard, PlayfulCardButton };
